"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.advance = void 0;
function advance(task, entry) {
    return {
        grammar_name: task.grammar_name,
        choice_name: task.choice_name,
        parts: task.parts,
        index: task.index,
        progress: [...task.progress, entry],
        id_head: task.id_head,
        id_body: task.id_body + format_entry(entry),
    };
}
exports.advance = advance;
function format_entry(entry) {
    const { choice_name, index } = entry;
    if (choice_name) {
        return `(:${choice_name}@${index})`;
    }
    else {
        return `(@${index})`;
    }
}
//# sourceMappingURL=task-advance.js.map